module.exports = __webpack_public_path__ + "static/img/gakg.efb4da8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/gakg.svg
// module id = qvOo
// module chunks = 2